import apiClient from './apiClient';
import { PaymentProvider, PlanType } from '../../types';

const subscriptionApi = {
  getMySubscription: () =>
    apiClient.get('/subscriptions/me').then((r) => r.data),

  getPlans: () =>
    apiClient.get('/subscriptions/plans').then((r) => r.data),

  initiatePayment: (planType: PlanType, paymentProvider: PaymentProvider) =>
    apiClient
      .post('/payments/initiate', { planType, paymentProvider })
      .then((r) => r.data),

  getPaymentStatus: (reference: string) =>
    apiClient.get(`/payments/status/${encodeURIComponent(reference)}`).then((r) => r.data),
};

export default subscriptionApi;
